/** Host capabilities are typed independently of the plugins that consume them. */
export type PluginService<T> = { readonly key: symbol; readonly valueType?: T };
export function pluginService<T>(name: string): PluginService<T> {
  return { key: Symbol(name) };
}
export class PluginHostServices {
  private readonly values = new Map<symbol, unknown>();
  provide<T>(service: PluginService<T>, value: T | undefined): this {
    this.values.set(service.key, value);
    return this;
  }
  get<T>(service: PluginService<T>): T | undefined {
    return this.values.get(service.key) as T | undefined;
  }
}
